import GetServices from "../components/getServices";
import CheckIsUserExist from "../components/checkIsUserExist";
import SentSMS from "../components/sentSMS";
import CheckSmsCode from "../components/checkSmsCode";
import PatientRegistration from "../components/PatientRegistration";
import ChoseLocation from "../components/ChoseLocation";
import ChooseSlot from "../components/ChooseSlot";
import CreateEvent from "../components/CreateEvent";
import React from "react";
import SentContactForm from "../components/SentContactForm";
import BranchingOption from "../components/helper/BranchingOption";
import ChooseApp from "../components/ChooseApp";
import ShowApp from "../components/ShowApp";
import RescheduleChooseSlot from "../components/RescheduleChooseSlot";
import CancelApp from "../components/CancelApp";
import RescheduleCreateEvent from "../components/RescheduleCreateEvent";
import CheckEmailCode from "../components/CheckEmailCode";
import IsThisYourEmail from "../components/IsThisYourEmail";
import SentEmail from "../components/SentEmail";
import CheckIfUserAuth from "../components/helper/CheckIfUserAuth";
import validation from "../components/helper/validation/validation";
import BranchingContactSteps from "../components/helper/BranchingContactSteps";
import {addLeadingZeros} from "../helpers/functions";
import StartSteps from "../components/StartOptions";
import GeneralInfo from "../components/generalInfo";

export const steps = [
    {
        id: 'CheckIfUserAuthTheFirst',
        waitAction: true,
        asMessage:true,
        replace:true,
        component: (
            <CheckIfUserAuth  trueStep={'say_hello'} falseStep={'say_hello'} />
        )
    },
    {
        id: 'say_hello',
        message: 'Hello I am  "PlexiDoc" ChatBot',
        trigger: 'say_how_can_help',
    },


    {
        id: 'say_how_can_help',
        message: 'How can I help?',
        trigger: 'option',
    },
    {
        id: 'option',
        waitAction:true,
        optionsForTranslate:true,
        metadata:{ options: [
            {value: 'BookingApp', label: 'Booking an Appointment', trigger: 'CheckIfUserAuth'},
            {value: 'CancelApp', label: 'Cancel Appointment', trigger: 'CheckIfUserAuth'},
            {value: 'RescheduleApp', label: 'Reschedule Appointment', trigger: 'CheckIfUserAuth'},
            {value: 'ContactUs', label: 'Contact us', trigger: 'contactUs_start'},
            {value: 'ShowMyAppointments', label: 'Show my appointments', trigger: 'CheckIfUserAuth'},
            {value: 'ClinicPhoneFax', label: 'Clinic phone number & fax', trigger: 'generalInfo'},
            {value: 'ClinicAddress', label: 'Clinic address', trigger: 'generalInfo'},
            {value: 'ClinicEmail', label: 'Clinic email', trigger: 'generalInfo'},
            {value: 'HowToArrive', label: 'How to arrive', trigger: 'generalInfo'},
        ]},
        component: (
            <StartSteps  showItems={4} />
        ),

    },

    {
        id: 'generalInfo',
        asMessage:true,

        component: (
            <GeneralInfo />
        ),
        trigger: "say_how_can_help"

    },
    //
    // {
    //     id: 'option',
    //     options: [
    //         {value: 'BookingApp', label: 'Booking an Appointment', trigger: 'CheckIfUserAuth'},
    //         {value: 'CancelApp', label: 'Cancel Appointment', trigger: 'CheckIfUserAuth'},
    //         {value: 'RescheduleApp', label: 'Reschedule Appointment', trigger: 'CheckIfUserAuth'},
    //         {value: 'ContactUs', label: 'Contact us', trigger: 'contactUs_start'},
    //         {value: 'LoadMore', label: 'Load More', trigger: 'contactUs_start'},
    //     ],
    // },

    {
        id: 'CheckIfUserAuth',
        waitAction: true,
        asMessage:true,
        replace:true,
        component: (
            <CheckIfUserAuth  trueStep={'branching_option'} falseStep={'start'} />
        )
    },


    {
        id: 'start',
        message: 'Good lets start',
        trigger: 'userInd_userID',
    },

    //----------- ask ID -------------------

    {
        id: 'userInd_userID',
        message: 'What is your id number?',
        trigger: 'userID',
    },

    {
        id: 'userID',
        user: true,
        trigger: 'UserData',
        inputAttributes:{
            inputMode:"numeric",
            pattern:"[0-9]*"
        },
        validator: validation.userIdNumber,
        mutation: (inputValue)=>{
            return addLeadingZeros(inputValue,9);
        }
    },

    {
        id: 'UserData',
        waitAction: true,
        asMessage:true,
        component: (
            <CheckIsUserExist/>
        )
    },


    // User identifier Process

    //----------- ask Name -------------------
    {
        id: 'cannot_find_you_in_system',
        message: 'I cannot find you in system. Would you like to register as a new patient? (This is a one time process)',
        trigger: 'yes_no_wouldYouLikeToRegister',
    },

    {
        id: 'yes_no_wouldYouLikeToRegister',
        options: [
            {value: '1', label: 'Yes', trigger: 'userInd_start'},
            {value: '0', label: 'No', trigger: 'pleaseLeaveMsgToClinic'},
        ]
    },


    {
        id: 'pleaseLeaveMsgToClinic',
        message: 'Please leave a msg to clinic',
        trigger: 'contactUs_start',
    },

    {
        id: 'userInd_start',
        message: 'Great lets continue. I need few details about you.',
        trigger: 'userInd_name',
    },

    {
        id: 'userInd_name',
        message: 'Name?',
        trigger: 'first_name',
    },

    {
        id: 'first_name',
        user: true,
        validator: validation.required,
        trigger: 'userInd_sayHello',
    },


    // ---- Patient registration
    {
        id: 'userInd_sayHello',
        message: 'Hello {previousValue}!',
        trigger: 'please_insert_last_name',
    },

    {
        id: 'please_insert_last_name',
        message: 'Please insert your Last name.',
        trigger: 'last_name',
    },
    {
        id: 'last_name',
        user: true,
        trigger: 'please_insert_DOB',
    },

    //
    // {
    //     id: 'please_insert_gender',
    //     message: 'Please insert your gender.',
    //     trigger: 'userGender',
    // },
    //
    // {
    //     id: 'userGender',
    //     options: [
    //         {value: 'male', label: 'Male', trigger: 'please_insert_DOB'},
    //         {value: 'female', label: 'Female', trigger: 'please_insert_DOB'},
    //     ],
    // },

    {
        id: 'please_insert_DOB',
        message: 'Please insert your date of birth.',
        trigger: 'dob_year_ask',
    },

    {
        id: 'dob_year_ask',
        message: 'Year:',
        trigger: 'dob_year',
    },

    {
        id: 'dob_year',
        user: true,
        validator: validation.dobYear,
        trigger: 'dob_month_ask',
    },

    {
        id: 'dob_month_ask',
        message: 'Month:',
        trigger: 'dob_month',
    },

    {
        id: 'dob_month',
        options: [
            {value: '1', label: '1', trigger: 'dob_day_ask'},
            {value: '2', label: '2', trigger: 'dob_day_ask'},
            {value: '3', label: '3', trigger: 'dob_day_ask'},
            {value: '4', label: '4', trigger: 'dob_day_ask'},
            {value: '5', label: '5', trigger: 'dob_day_ask'},
            {value: '6', label: '6', trigger: 'dob_day_ask'},
            {value: '7', label: '7', trigger: 'dob_day_ask'},
            {value: '8', label: '8', trigger: 'dob_day_ask'},
            {value: '9', label: '9', trigger: 'dob_day_ask'},
            {value: '10', label: '10', trigger: 'dob_day_ask'},
            {value: '11', label: '11', trigger: 'dob_day_ask'},
            {value: '12', label: '12', trigger: 'dob_day_ask'},
        ],
    },

    {
        id: 'dob_day_ask',
        message: 'Day:',
        trigger: 'dob_day',
    },

    {
        id: 'dob_day',
        user: true,
        validator: validation.dobDay,
        trigger: 'pleaseInsertYourPhone',
    },

    //----------- ask Phone -------------------
    {
        id: 'yes_no_isThisIsYourPhone',
        options: [
            {value: '1', label: 'Yes', trigger: 'SentSMS'},
            // {value: '1', label: 'Yes', trigger: 'branching_option'},
            {value: '0', label: 'No', trigger: 'IsThisYourEmail'},
        ]
    },

    {
        id: 'pleaseInsertYourPhone',
        message: 'Please insert your phone number.',
        trigger: 'userPhone',
    },

    {
        id: 'afterMinuteSmsSent',
        options: [
            {value: '1', label: 'Send code again', trigger: 'SentSMS'},
            {value: '2', label: 'Use different method', trigger: 'IsThisYourEmail'},
            {value: '3', label: 'Contact clinic', trigger: 'contactUs_start'},
        ],
    },

    {
        id: 'userPhone',
        user: true,
        trigger: 'SentSMS',
    },

    {
        id: 'SentSMS',
        waitAction: true,
        asMessage:true,
        hideInput:false,
        component: (
            <SentSMS/>
        )
    },

    {
        id: 'we_sent_you_sms_code',
        message: 'We sent you sms code, please insert the code you got',
        trigger: 'smsCode',
    },

    {
        id: 'smsCode',
        user: true,
        trigger: 'checkSmsCode',
    },

    {
        id: 'checkSmsCode',
        waitAction: true,
        asMessage:true,
        replace:true,
        component: (
            <CheckSmsCode trueStep={'smsCode_correct'} falseStep={'smsCode_not_correct'} continueRegisration={'NewPatient'} />
        ),
    },

    {
        id: 'smsCode_not_correct',
        message: 'You insert not correct code.',
        trigger: 'smsCode_not_correct_what_to_do',
    },
    {
        id: 'smsCode_not_correct_what_to_do',
        message: 'What you want to do?',
        trigger: 'afterSmsCode_not_correct',
    },

    {
        id: 'afterSmsCode_not_correct',
        options: [
            {value: '1', label: 'Enter again', trigger: 'ReInsertSmsCode'},
            {value: '2', label: 'Resend the code', trigger: 'SentSMS'},
            {value: '3', label: 'Contact clinic', trigger: 'contactUs_start'},
        ],
    },
    {
        id: 'ReInsertSmsCode',
        update: 'smsCode',
        trigger: 'checkSmsCode',
    },

    {
        id: 'smsCode_correct',
        message: "Thank you it's correct code.",
        trigger: 'branching_option',
    },

    {
        id: 'NewPatient',
        waitAction: true,
        asMessage:true,
        component: (
            <PatientRegistration />
        ),
    },


    //--------- email verification
    {
        id: 'IsThisYourEmail',
        asMessage:true,
        waitAction: true,
        component:
            <IsThisYourEmail />
        ,
    },

    {
        id: 'yes_no_isThisIsYourEmail',
        options: [
            {value: '1', label: 'Yes', trigger: 'SentEmail'},
            // {value: '1', label: 'Yes', trigger: 'branching_option'},
            {value: '0', label: 'No', trigger: 'please_contact_support'},
        ]
    },

    {
        id: 'SentEmail',
        waitAction: true,
        asMessage:true,
        replace:true,
        component:
            <SentEmail />
        ,
    },

    {
        id: 'we_sent_you_email_code',
        message: "We sent you email with code, please insert the code you got",
        trigger: 'emailCode',
    },

    {
        id: 'please_contact_support',
        message: "Please contact support:",
        trigger: 'contactUs_start',
    },

    {
        id: 'emailCode',
        user: true,
        trigger: 'CheckEmailCode',
    },

    {
        id: 'CheckEmailCode',
        waitAction: true,
        asMessage:true,
        replace:true,
        component: (
            <CheckEmailCode />
        ),
    },

    {
        id: 'emailCode_not_correct',
        message: 'You insert not correct code.',
        trigger: 'emailCode',
    },

    {
        id: 'emailCode_correct',
        message: "Thank you it's correct code.",
        trigger: 'branching_option',
    },
// -------------- email verification  End

    {
        id: 'branching_option',
        waitAction: true,
        asMessage:true,
        replace:true,
        component: (
            <BranchingOption  have_appointments_trigger={"patient_have_appointments"}/>
        ),
    },

    {
        id: 'patient_have_appointments',
        message: 'I see you already have a scheduled appointment, what would you like to do?',
        trigger: 'already_have_appointments_options',
    },

    {
        id: 'already_have_appointments_options',
        options: [
            {value: 'RescheduleApp', label: 'Reschedule Appointment', trigger: 'ChooseAppForReschedule'},
            {value: 'BookingApp', label: 'Add another appointment', trigger: 'getServices_ask'},
            {value: 'CancelApp', label: 'Cancel Appointment', trigger: 'ChooseAppForCancel'},
        ],
    },

    {
        id: 'ChooseAppForCancel',
        waitAction: true,
        component: (
            <ChooseApp chooseFor={'cancel'} />
        ),
        trigger: 'CancelApp',
    },
    {
        id: 'ChooseAppForReschedule',
        waitAction: true,
        component: (
            <ChooseApp chooseFor={'reschedule'} />
        ),
        trigger: 'CancelAppForReschedule',
    },

    {
        id: 'show_my_appointment',
        component: (
            <ShowApp />
        ),
        trigger: 'say_how_can_help',
    },


    {
        id: 'CancelAppForReschedule',
        waitAction: true,
        asMessage:true,
        replace:true,
        component: (
            <CancelApp cancelFor={'reschedule'} />
        ),
        trigger: 'CancelApp',
    },
    {
        id: 'CancelApp',
        waitAction: true,
        asMessage:true,
        replace:true,
        component: (
            <CancelApp />
        ),
        trigger: 'CancelApp',
    },

    {
        id: 'cancelAppSuccess_msg',
        message: "Please select the appointment you want to reschedule.",
        trigger: 'would_you_like_to_do_something_else',
    },

    //--------- Chose Services ------------

    {
        id: 'getServices_ask',
        message: 'What service would you like?',
        trigger: 'serviceId',
    },

    {
        id: 'serviceId',
        waitAction: true,
        component: (
            <GetServices/>
        ),
        trigger: 'pleaseChoseLocation',
    },

    //--------- Chose location ------------

    {
        id: 'pleaseChoseLocation',
        message: 'Please choose location',
        trigger: 'location',
    },

    {
        id: 'location',
        waitAction: true,
        component: (
            <ChoseLocation/>
        ),
        trigger: 'pleaseChoseDayAndTime',
    },

    {
        id: 'pleaseChoseDayAndTime',
        message: 'Great please choose the day and time that best for you',
        trigger: 'slot',
    },

    {
        id: 'slot',
        waitAction: true,
        component: (
            <ChooseSlot/>
        ),
        trigger: 'createEvent',
    },

    {
        id: 'reschedulePleaseChoseDayAndTime',
        message: 'Please choose the new day and time that best for you',
        trigger: 'RescheduleChooseSlot',
    },

    {
        id: 'RescheduleChooseSlot',
        waitAction: true,
        component: (
            <RescheduleChooseSlot/>
        ),
        trigger: 'RescheduleCreateEvent',
    },

    {
        id: 'RescheduleCreateEvent',
        waitAction: true,
        asMessage:true,
        component: (
            <RescheduleCreateEvent/>
        ),
        trigger: 'userInd_start',
    },

   {
        id: 'createEvent',
        waitAction: true,
        asMessage:true,

        component: (
            <CreateEvent/>
        ),
        trigger: 'userInd_start',
    },


    {
        id: 'would_you_like_to_do_something_else',
        message: 'Would you like to do something else?',
        trigger: 'yes_no_toStartOrFinish',
    },

    {
        id: 'yes_no_toStartOrFinish',
        options: [
            {value: 1, label: 'Yes', trigger: 'option'},
            {value: 0, label: 'No', trigger: 'theEnd'},
        ],
    },

    {
        id: 'theEnd',
        message: 'Good By!',
        end: true,
    },

    {
        id: '5',
        component: (
            <div> "Cancel Appointment </div>
        ),
        end: true,
    },

    {
        id: '6',
        component: (
            <div> Reschedule Appointment </div>
        ),
        end: true,
    },

    {
        id: 'contactUs_start',
        waitAction: true,
        asMessage:true,
        replace:true,
        component: (
            <BranchingContactSteps  />
        ),
        trigger: 'patient_name',
    },


    {
        id: 'please_insert_patient_name',
        message: 'Please insert your name',
        trigger: 'patient_name',
    },

    {
        id: 'patient_name',
        user: true,
        validator: validation.required,
        trigger: 'please_insert_your_phone',
    },

    {
        id: 'please_insert_your_phone',
        message: 'Please insert your phone',
        trigger: 'patient_phone',
    },

    {
        id: 'patient_phone',
        user: true,
        validator: validation.required,
        trigger: 'please_insert_your_email',
    },

    {
        id: 'please_insert_your_email',
        message: 'Please insert your email',
        trigger: 'patient_email',
    },

    {
        id: 'patient_email',
        user: true,
        validator: validation.email,
        trigger: 'please_insert_your_message',
    },

    {
        id: 'please_insert_your_message',
        message: 'Please insert your message',
        trigger: 'patient_message',
    },
    {
        id: 'patient_message',
        user: true,
        validator: validation.required,
        trigger: 'SentContactForm',
    },

    {
        id: 'SentContactForm',
        waitAction: true,
        asMessage:true,
        component: (
           <SentContactForm/>
        ),
        trigger: 'would_you_like_to_do_something_else',
    },

];
